<main>
  <header>
    <div>
      <h1>
        @if (originalBusiness()) {
          {{ originalBusiness()?.code }} | {{ originalBusiness()?.name }}
        } @else {
          {{ 'Header_Tittle_New_Business' | translateWF: 'New Business' }}
        }
      </h1>
    </div>
    <div class="buttons">
      @if (!isReadOnly) {
        <p-button
          [label]="'Save' | translateWF: 'Save'"
          (click)="save()"
          [disabled]="(canAssignSites ? siteIdsControl.invalid : businessType.invalid) || nameBusiness.invalid || countryCodeBusiness.invalid"
        />
      }
      <p-button [label]="isReadOnly ? ('Back' | translateWF: 'Back') : ('Cancel' | translateWF: 'Cancel')" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <div class="content">
    <p-panel header="Filter">
      <p-card>
        <div class="grid-auto-4 mt-4">
          <div class="form-box">
            <label for="name">Name</label>
            <input type="text" [formControl]="nameBusiness" pInputText class="w-full" [readonly]="isReadOnly" />
          </div>
          <div class="form-box">
            <label for="name">Tax Indicator Code</label>
            <input type="text" [formControl]="taxIndicationCodeBusiness" pInputText class="w-full" [readonly]="isReadOnly" />
          </div>
          <!-- Where the company is (#5121). Beside the tax id because the two answer the same kind of
             question about the entity, and a filter or a withholding rule usually needs both. -->
          <div class="form-box">
            <label for="countryCode">{{ 'Business_Country' | translateWF: 'Country' }} <span class="text-red-500">*</span></label>
            <p-select
              inputId="countryCode"
              [formControl]="countryCodeBusiness"
              [options]="countryOptions()"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              filterBy="label"
              appendTo="body"
              styleClass="w-full"
              [placeholder]="'Business_Country_Ph' | translateWF: 'Select country'"
              [ngClass]="{ 'ng-invalid ng-dirty': countryCodeBusiness.invalid && countryCodeBusiness.touched }"
            />
          </div>
          @if (!canAssignSites) {
            <div class="form-box">
              <label for="">Business Type</label>
              <p-multiselect
                [formControl]="businessType"
                [options]="businessTypeSuggestions()"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full"
                [disabled]="isReadOnly"
              ></p-multiselect>
            </div>
          }
        </div>

        @if (canAssignSites) {
          <div class="grid-12 mt-4">
            <div class="span-6">
              <div class="form-box">
                <label>{{ 'Sites' | translateWF: 'Sites' }}</label>
                <p-multiSelect
                  appendTo="body"
                  [options]="availableSites"
                  optionLabel="name"
                  optionValue="id"
                  [formControl]="siteIdsControl"
                  display="chip"
                  [placeholder]="'Select_Sites' | translateWF: 'Select sites'"
                  styleClass="w-full"
                  [disabled]="isReadOnly"
                ></p-multiSelect>
                @if (siteIdsControl.errors?.['required']) {
                  <div class="text-red-500 text-sm">
                    {{ 'Site_Required' | translateWF: 'At least one site must be selected.' }}
                  </div>
                }
              </div>
            </div>
          </div>

          @if (siteBusinessTypeGroups.length > 0) {
            <div class="grid-12 mt-4">
              <div class="span-12">
                <div class="form-box">
                  <label>{{ 'Business_Types_By_Site' | translateWF: 'Business Types by Site' }}</label>
                  <p-accordion [multiple]="true" [(value)]="expandedSiteIds">
                    @for (group of siteBusinessTypeGroups; track group.siteId) {
                      <p-accordion-panel [value]="group.siteId">
                        <p-accordion-header>{{ getSiteName(group.siteId) }}</p-accordion-header>
                        <p-accordion-content>
                          <div [formGroup]="group.formGroup">
                            <p-multiselect
                              appendTo="body"
                              formControlName="businessTypes"
                              [options]="businessTypeSuggestions()"
                              optionLabel="label"
                              optionValue="value"
                              display="chip"
                              styleClass="w-full"
                              [disabled]="isReadOnly"
                            ></p-multiselect>
                          </div>
                        </p-accordion-content>
                      </p-accordion-panel>
                    }
                  </p-accordion>
                </div>
              </div>
            </div>
          }
        }
      </p-card>
    </p-panel>

    <!-- Role details (#4892) — a role's settings are too large to sit as a tab beside the addresses, so each
         one keeps its own page and this is the way in. The role itself is still granted above. -->
    <p-panel [header]="'Business_RoleDetails' | translateWF: 'Role Details'">
      <div class="grid-auto-3">
        @for (card of roleCards; track card.key) {
          <p-card styleClass="h-full" [class.opacity-60]="!card.assigned">
            <div class="row-start-start">
              <i [ngClass]="card.icon" class="text-xl text-[var(--p-primary-color)] mt-1"></i>
              <div class="col-sm">
                <div class="row-sm-start-center">
                  <span class="font-semibold">{{ card.title | translateWF: card.title }}</span>
                  @if (card.assigned) {
                    <p-tag severity="success" [value]="'Assigned' | translateWF: 'Assigned'" />
                  } @else {
                    <span class="text-sm text-[var(--p-text-muted-color)]">{{ 'Not_Assigned' | translateWF: 'Not assigned' }}</span>
                  }
                </div>
                <span class="text-sm text-[var(--p-text-muted-color)]">{{ card.description | translateWF: card.description }}</span>
                <p-button
                  [label]="card.linkLabel | translateWF: card.linkLabel"
                  icon="pi pi-angle-right"
                  iconPos="right"
                  variant="text"
                  styleClass="p-0"
                  [disabled]="!card.enabled"
                  (click)="openRole(card)"
                />
              </div>
            </div>
          </p-card>
        }
      </div>
      <ng-template pTemplate="footer">
        <small class="text-[var(--p-text-muted-color)] font-normal">
          {{
            'Business_RoleDetails_Hint'
              | translateWF
                : 'Each role this business holds keeps its own page of
          settings.'
          }}
        </small>
      </ng-template>
    </p-panel>

    <!-- <section> -->
    <!-- there problem with the primeNg tabs  -->
    <!-- <p-tabs [value]="value">
        <p-tablist>
          <p-tab [value]="0">Addresses</p-tab>
          <p-tab [value]="1">Representatives</p-tab>
          <p-tab [value]="2">Provider Detail</p-tab>
          <p-tab [value]="3">Client Detail</p-tab>
          <p-tab [value]="4">Lots</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0"> lorem lorem </p-tabpanel>
          <p-tabpanel [value]="1"> lorem lorem </p-tabpanel>
          <p-tabpanel [value]="2"> lorem lorem </p-tabpanel>
          <p-tabpanel [value]="3"> lorem lorem </p-tabpanel>
          <p-tabpanel [value]="4"> lorem lorem </p-tabpanel>
        </p-tabpanels>
      </p-tabs> -->
    <!-- </section> -->

    <div>
      <div class="col">
        <p-selectbutton [options]="tabsToDisplay" [formControl]="selectTab" optionLabel="label" optionValue="value" />
        @switch (selectTab.value) {
          @case (0) {
            <app-addresses-viewer [(addresses)]="addresses" [viewOnly]="isReadOnly" />
          }
          @case (1) {
            <app-representatives-viewer [representatives]="representatives" (representativesChange)="representatives = $event" [viewOnly]="isReadOnly" />
          }
          @case (3) {
            <app-client-details-viewer [(client)]="client" [viewOnly]="isReadOnly" />
          }

          @case (4) {
            <p-panel [header]="'Lots' | translateWF: 'Lots'">
              @if (!isReadOnly) {
                <ng-template pTemplate="icons">
                  <p-button [label]="'Add' | translateWF: 'Add'" variant="outlined" icon="pi pi-plus" (click)="openLotsIdModal()" />
                </ng-template>
              }
              <p-card data-variant="compact">
                <!-- Table of Lots -->
                <p-table [value]="lotIdValues" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25, 50, 100]" [rowHover]="true">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>{{ 'Lots' | translateWF: 'Lots' }}</th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-lot let-i="rowIndex">
                    <tr>
                      <td>{{ lot }}</td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td class="text-center">{{ 'General_NoRecords' | translateWF: 'No records found' }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-card>
            </p-panel>
          }

          @case (5) {
            <app-tax-authorizations-viewer [businessId]="originalBusiness()?.id ?? null" [businessName]="originalBusiness()?.name ?? null" [viewOnly]="isReadOnly" />
          }
        }
      </div>
    </div>
  </div>
</main>
